import React from 'react';
import { observer } from '@a2d24/care-at-work-state/mobx-react-lite';
import { styled } from '@a2d24-ui/theme';
import { useNavigate } from 'react-router-dom';
import { getEngine } from '@a2d24/react-engine';
import { useStores } from '@a2d24/care-at-work-state/stores';
import MFALandingScreen from './MFALandingScreen';
import MFASelector from './MFASelector';
import SetupSMS from './SetupSMS';
import SetupEmail from './SetupEmail';
import useTimeout from '../../hooks/useTimeout';

const engine = getEngine();

const Logo = engine.providers('Logo', () => () => null)();

const SetupMFAFirstTime = () => {
    const navigate = useNavigate();
    const [screen, setScreen] = React.useState('landing-screen');

    const { mfaStore } = useStores();
    const { mfaPending } = mfaStore;

    // Give the user 10 minutes to set up MFA
    const timeoutRef = useTimeout(() => {
        mfaStore.abandonChallenge();
        mfaStore.clearMfaRequired();
        mfaStore.reset(true);
        navigate('/login');
    }, 10 * 60 * 1000);

    React.useEffect(() => {
        mfaStore.setErrorMessage(null);

        if (!mfaPending) {
            navigate('/login');
        }
    }, []);

    return (
        <Container>
            <Logo />
            {screen === 'landing-screen' && <MFALandingScreen setScreen={setScreen} />}
            {screen === 'home' && <MFASelector setScreen={setScreen} />}
            {screen === 'sms-screen' && <SetupSMS setScreen={setScreen} />}
            {screen === 'email-screen' && <SetupEmail setScreen={setScreen} />}
        </Container>
    );
};

export default observer(SetupMFAFirstTime);

const Container = styled('div', {
    width: '100vw',
    minHeight: '100vh',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    placeItems: 'center',

    '> img': {
        justifySelf: 'start',
        margin: '2ch 4ch',
        maxWidth: '300px',
    },
});
